module.exports = ".mat-table {\n  width: 100%;\n  -webkit-box-shadow: 0px 0px 0px !important;\n          box-shadow: 0px 0px 0px !important;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  display: -ms-inline-grid;\n  display: inline-grid; }\n\n.table-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  overflow: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/nota-cargo/agregar-editar/nota-cargo-detalle.component.scss
// module id = ./src/app/nota-cargo/agregar-editar/nota-cargo-detalle.component.scss
// module chunks = main